export interface SettingsDefinitions {
  [key: string]: {
    type: "string" | "boolean";
    defaultValue: string | boolean | null;
  };
}

// UPDATE CODE HERE WHEN ADDING NEW SETTING (2)
export function getSettingDefinitions(iframe: boolean): SettingsDefinitions {
  return {
    idEmbed: { type: "string", defaultValue: null },

    theme: { type: "string", defaultValue: "light" },
    lt_surfaceColor: { type: "string", defaultValue: "#F8F8F8" },
    dt_surfaceColor: { type: "string", defaultValue: "#0e1315" },
    lt_textColor: { type: "string", defaultValue: "#262626" },
    dt_textColor: { type: "string", defaultValue: "#F8F8F8" },
    lt_primaryColor: { type: "string", defaultValue: "#26658C" },
    dt_primaryColor: { type: "string", defaultValue: "#7FA9AB" },

    css: { type: "string", defaultValue: null },
    fontLink: {
      type: "string",
      defaultValue:
        "https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap",
    },
    fontFamily: { type: "string", defaultValue: "Ubuntu, Sans-serif" },
    departments: { type: "string", defaultValue: null },
    fontSize: { type: "string", defaultValue: "16px" },
    iframe_startPage: { type: "string", defaultValue: "jobs" },
    iframe_embedOrigin: { type: "string", defaultValue: null },
    iframe_pathBinding: { type: "string", defaultValue: null },
    locale: { type: "string", defaultValue: "nb" },
    iframe_overrideLocale: { type: "string", defaultValue: null }, //  not stored in db, set by loadCvpEmbedded
    iframe_overrideTheme: { type: "string", defaultValue: null }, // not stored in db, set by loadCvpEmbedded
    logoJobFallback: { type: "string", defaultValue: null },
    logoPrimary: { type: "string", defaultValue: "DEFAULT_LOGO" },
    welcomePicture: { type: "string", defaultValue: "DEFAULT_WELCOME_PICTURE" },
    favicon: { type: "string", defaultValue: "DEFAULT_FAVICON" },
    menu_extraLinks: { type: "string", defaultValue: null },
    extraFields: { type: "string", defaultValue: null },
    extraApplicationFields: { type: "string", defaultValue: null },
    jobview_defaultBirthDate: { type: "string", defaultValue: null },

    profile_availableFrom: { type: "string", defaultValue: "visible" },
    profile_accNumber: { type: "string", defaultValue: "visible" },
    profile_nextOfKin: { type: "string", defaultValue: "visible" },
    profile_swift: { type: "string", defaultValue: "visible" },
    profile_iban: { type: "string", defaultValue: "visible" },
    profile_idNumber: { type: "string", defaultValue: "visible" },
    profile_birthDate: { type: "string", defaultValue: "visible" },
    profile_postalAddress: { type: "string", defaultValue: "visible" },
    profile_city: { type: "string", defaultValue: "visible" },
    profile_zipCode: { type: "string", defaultValue: "visible" },
    profile_nationality: { type: "string", defaultValue: "visible" },
    profile_phone2: { type: "string", defaultValue: "visible" },
    profile_gender: { type: "string", defaultValue: "visible" },

    createProfile_attachments: { type: "string", defaultValue: "hidden" },
    createProfile_birthDate: { type: "string", defaultValue: "hidden" },
    createProfile_phone: { type: "string", defaultValue: "hidden" },
    createProfile_zipCode: { type: "string", defaultValue: "hidden" },
    createProfile_address: { type: "string", defaultValue: "hidden" },
    createProfile_city: { type: "string", defaultValue: "hidden" },
    createProfile_nationality: { type: "string", defaultValue: "hidden" },
    createProfile_gender: { type: "string", defaultValue: "hidden" },
    createProfile_availableFrom: { type: "string", defaultValue: "hidden" },

    application_phone: { type: "string", defaultValue: "hidden" },
    application_dob: { type: "string", defaultValue: "hidden" },
    application_zipCode: { type: "string", defaultValue: "hidden" },
    application_address: { type: "string", defaultValue: "hidden" },
    application_city: { type: "string", defaultValue: "hidden" },
    application_nationality: { type: "string", defaultValue: "hidden" },
    application_gender: { type: "string", defaultValue: "hidden" },
    application_availableFrom: { type: "string", defaultValue: "hidden" },
    application_attachments: {
      type: "string",
      defaultValue: "visible_required",
    },

    pwa_enabled: { type: "boolean", defaultValue: false },
    jobview_prioAdrDepartment: { type: "boolean", defaultValue: false },
    jobview_prioFromDateText: { type: "boolean", defaultValue: true },
    jobview_showContactImage: { type: "boolean", defaultValue: false },
    jobview_showMunicipality: { type: "boolean", defaultValue: true },
    jobview_showNumCandidates: { type: "boolean", defaultValue: true },
    application_requireCoverLetter: { type: "boolean", defaultValue: true },
    jobview_lastDayOfJob: { type: "boolean", defaultValue: false },
    frontpage_showJoblist: { type: "boolean", defaultValue: true },
    frontpage_showWelcome: { type: "boolean", defaultValue: !iframe },
    iframe: { type: "boolean", defaultValue: true },
    iframe_joblist_showLoginButton: { type: "boolean", defaultValue: true },
    iframe_loginOldPortal: { type: "boolean", defaultValue: false },
    iframe_showCardMenu: { type: "boolean", defaultValue: true },
    profile_chooseKnowledgeLevel: { type: "boolean", defaultValue: false },
    timesheets_enabled: { type: "boolean", defaultValue: true },
    timesheets_increasedLookup: { type: "boolean", defaultValue: false },
    messages_enabled: { type: "boolean", defaultValue: true },
    jobview_enabled: { type: "boolean", defaultValue: true },
    workschedule_enabled: { type: "boolean", defaultValue: false },
    leave_enabled: { type: "boolean", defaultValue: false },
    leave_personnelHandbookUrl: { type: "string", defaultValue: null },
    leave_showVacationSaldo: { type: "boolean", defaultValue: false },
    leave_vacationEntitlement: { type: "string", defaultValue: "25" },
    showTopBar: { type: "boolean", defaultValue: !iframe },
    showSidebar: { type: "boolean", defaultValue: !iframe },
    stopWatch_enabled: { type: "boolean", defaultValue: false },
    timesheets_compareNormalHours: { type: "boolean", defaultValue: false },

    // New setting: close the CV portal for this concern
    cvp_closed: { type: "boolean", defaultValue: false },
  };
}
